import React, { createContext, useEffect, useState } from 'react';

import { httpGet, useInterval } from '../utils';

const INTERVAL_TIME = 60 * 1000;
export const FeatureFlagContext = createContext();

export const FeatureFlagProvider = ({ children }) => {
    const [featureFlags, setFeatureFlags] = useState({});

    const getFeatureFlags = async () => {
        try {
            const response = await httpGet(`/Settings/featureFlags`);
            setFeatureFlags(response.data);
        } catch (error) {
            console.error('Failed to get feature flags', error);
        }
    };

    useEffect(() => {
        getFeatureFlags();
    }, []);

    useInterval(getFeatureFlags, INTERVAL_TIME);

    return <FeatureFlagContext.Provider value={featureFlags}>{children}</FeatureFlagContext.Provider>;
};
